











































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import DateTime from 'vuejs-datetimepicker';
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import CarEntity from '@/entities/Car';
import CarService from '@/services/car';
import PictureService from '@/services/picture';
import Picture from '@/entities/Picture';
import CarOption from '@/entities/CarOption';
import ModalService from '@/services/modal';
import Bid from '@/entities/Bid';
import Purchase from '@/entities/Purchase';

interface Field {
    name: string;
}

@Component({
    components: {
        DateTime,
        VueUploadMultipleImage,
    },
})
export default class Car extends Vue {
    carService = new CarService();

    pictureService = new PictureService();

    modalService = new ModalService();

    carEntity: CarEntity = null;

    fetchedSelectOptions: any = null;

    loadUploader = true;

    numberOfImagesBeingProcessed = 0;

    latestMakeId: string = null;

    bids: Bid[] = [];

    purchases: Purchase[] = [];

    activeTab = 'car';

    fields = [
        {
            label: 'Make',
            name: 'makeId',
            type: 'select',
            from: 'makes',
        },
        {
            label: 'Model',
            name: 'modelId',
            type: 'select',
            from: 'models',
        },
        {
            label: 'Title',
            name: 'title',
            type: 'text',
        },
        {
            label: 'Fuel',
            name: 'fuelTypeId',
            type: 'select',
            from: 'fuel_types',
        },
        {
            label: 'Transmission',
            name: 'transmissionTypeId',
            type: 'select',
            from: 'transmission_types',
        },
        {
            label: 'Description',
            name: 'description',
            type: 'textarea',
        },
        {
            label: 'First Registration',
            name: 'firstRegistration',
            type: 'text',
        },
        {
            label: 'Mileage',
            name: 'mileage',
            type: 'text',
        },
        {
            label: 'Engine',
            name: 'engine',
            type: 'number',
        },
        {
            label: 'Kw',
            name: 'kw',
            type: 'number',
        },
        {
            label: 'Price',
            name: 'price',
            type: 'number',
        },
        {
            label: 'Start price',
            name: 'startPrice',
            type: 'number',
        },
        {
            label: 'Vat Deductible',
            name: 'vatDeductible',
            type: 'checkbox',
        },
        {
            label: 'CO2 Value',
            name: 'co2Value',
            type: 'number',
        },
        {
            label: 'Active Till',
            name: 'activeTill',
            type: 'datetime',
        },
        {
            label: 'Color',
            name: 'colorId',
            type: 'select',
            from: 'colors',
        },
    ];

    get car(): CarEntity {
        if (!this.carEntity) {
            this.setCar();
        }

        return this.carEntity;
    }

    get selectOptions(): any {
        if (!this.fetchedSelectOptions) {
            this.fetchSelectOptions();
        }

        return this.fetchedSelectOptions || [];
    }

    setCar() {
        if (this.$route.params.uuid === 'new') {
            this.carEntity = new CarEntity();
        } else {
            this.carService.get(this.$route.params.uuid)
                .then((car) => {
                    this.carEntity = car;
                });
            this.carService.bids(this.$route.params.uuid)
                .then((bids) => {
                    this.bids = bids;
                });
            this.carService.purchases(this.$route.params.uuid)
                .then((purchases) => {
                    this.purchases = purchases;
                });
        }
    }

    fetchSelectOptions() {
        this.carService.props().then((options: CarOption[]) => {
            this.fetchedSelectOptions = options;
            this.fetchedSelectOptions.damage = [
                {
                    id: 'damaged',
                    name: 'Damaged',
                },
                {
                    id: 'accident',
                    name: 'Accident',
                },
            ];
        });
    }

    archive() {
        this.modalService.showConfirmationModal(
            'Please confirm',
            'After a car gets archived it is not listed anymore, the only way to get to it then is by direct link',
            () => this.doArchive(),
        );
    }

    doArchive() {
        this.carService.archive(this.car)
            .then(() => {
                this.$router.replace('/manage/cars');
            });
    }

    save() {
        this.carService.save(this.car)
            .then((car) => {
                this.carEntity = car;
                this.$nextTick(() => this.$router.replace('/manage/cars'));
            })
            .catch(({ response }) => {
                if (response.status === 422) {
                    this.modalService.showInfoModal(
                        'Could not save',
                        this.errorsToUnordedredList(response.data.errors),
                    );
                }
            });
    }

    errorsToUnordedredList(errors: any) {
        const listItems = Object.keys(errors).map((key) => `<li key="${key}">${errors[key][0]}</li>`);

        return `<ul>${listItems}</ul>`;
    }

    uploadImageSuccess(formData: any, index: any, fileList: any) {
        this.numberOfImagesBeingProcessed += 1;
        this.pictureService.uploadData(fileList[index].path, fileList[index].name, 'cars')
            .then((picture: Picture) => {
                this.car.addPicture(picture);
            })
            .finally(() => {
                this.numberOfImagesBeingProcessed -= 1;
            });
    }

    @Watch('numberOfImagesBeingProcessed')
    reloadUploader(numberOfImagesBeingProcessed: number) {
        if (numberOfImagesBeingProcessed === 0) {
            this.loadUploader = false;

            this.$nextTick(() => {
                this.loadUploader = true;
            });
        }
    }

    @Watch('car', { deep: true })
    resetModels(car: CarEntity) {
        if (!this.selectOptions.makes) {
            setTimeout(() => {
                this.resetModels(car);
            }, 300);
        } else if (this.latestMakeId !== car.makeId) {
            if (this.latestMakeId) {
                this.car.modelId = null;
            }
            this.latestMakeId = car.makeId;
            this.selectOptions.models = this.selectOptions.makes
                .find((make: any) => make.id === this.latestMakeId)
                .models;
        }
    }
}
